import { useEffect, useRef, useState } from "react";
import { MOBILE_BREAKPOINT } from "../constants";

export const useIsMobile = (breakpoint: number = MOBILE_BREAKPOINT) => {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = containerRef.current;
    if (!element) return;

    const update = () => {
      setIsMobile(element.offsetWidth <= breakpoint);
    };

    update();

    const resizeObserver = new ResizeObserver(update);
    resizeObserver.observe(element);

    return () => resizeObserver.disconnect();
  }, [breakpoint]);

  return { isMobile, containerRef };
};

export default useIsMobile;
